import Notification from '@rio-cloud/rio-uikit/Notification';

import type { RootDispatch, RootState } from '../../../../configuration/setup/store';
import { productApiSlice } from '../../api/product/productApiSlice';
import { apiCallAction } from '../../api/redux/api.redux';
import { ApiCalls } from '../../api/redux/types';
import { checkoutActions, getSelectedProductId, getSelectedProductLevel } from '../redux/checkout.redux';
import { isMultiLevelProduct, type Product } from '../redux/types';

export const fetchCheckoutProductDetailsThunk = (dispatch: RootDispatch, getState: () => RootState): Promise<void> => {
    const productId = getSelectedProductId(getState());
    const productLevel = getSelectedProductLevel(getState());

    if (!productId) {
        return Promise.reject();
    }
    dispatch(apiCallAction(ApiCalls.CHECKOUT_PRODUCT_DETAILS, true, false));
    dispatch(checkoutActions.setSelectedProduct(undefined));
    return dispatch(productApiSlice.endpoints.getProductDetails.initiate(productId, { subscribe: false }))
        .unwrap()
        .then((response: Product) => {
            dispatch(checkoutActions.setSelectedProduct(response));
            if (
                isMultiLevelProduct(response) &&
                (!productLevel || !response.levels.some(it => it.level === productLevel))
            ) {
                dispatch(apiCallAction(ApiCalls.CHECKOUT_PRODUCT_DETAILS, false, true));
                Notification.error('No or invalid target level provided for the checkout, please add as URL param');
            }
            dispatch(apiCallAction(ApiCalls.CHECKOUT_PRODUCT_DETAILS, false));
        })
        .catch(error => {
            if (typeof error === 'object' && error !== null && 'status' in error && error.status === 404) {
                dispatch(apiCallAction(ApiCalls.CHECKOUT_PRODUCT_DETAILS, false, false));
            } else {
                dispatch(apiCallAction(ApiCalls.CHECKOUT_PRODUCT_DETAILS, false, true));
            }
        });
};
